'use strict';
/**
 * Add-on to rmChartist directive
 * Show the tooltip on hover on the chart points
 * It will set the $scope.point to yours scope, so you can access current selected point via "point" expression
 * Point object content: {value: 624, x: 381.3333333333333, y: 25.85714285714286, index: 4}
 * @example
 * <div rm-chartist="graph">
     <div rm-chartist-tooltip>
        Tooltip template content goes here.
        It will be transcluded, so you can access your's controller scope easily.
        <pre>{{point | json}}</pre>
     </div>
   </div>
 */
app.directive('rmChartistTooltip', function ($timeout, $window) {
  var HIDE_DELAY = 700;
  /**
   * fitRectangleToTarget
   * @param anchorPoint {{x: number, y: number}}
   * @param rectangleToFit {{width: number}}
   * @param targetRectange {{width: number}}
   * @returns {{left: number}}
   */
  var fitRectangleToTarget = function (anchorPoint, rectangleToFit, targetRectange) {
    // 20 is a magic number, don't touch :)
    var containerWidth = targetRectange.width;
    var targetWidth = rectangleToFit.width;
    var left = Math.max(anchorPoint.x, targetWidth / 2);
    if (left > (containerWidth - targetWidth / 2)) {
      left = containerWidth - targetWidth / 2;
    }
    return {
      left: left
    };
  };
  return {
    replace: true,
    transclude: true,
    templateUrl: '/app/directives/rm-chartist-tooltip/rm-chartist-tooltip.html',
    link: function ($scope, el) {
      // Tooltip pointer (arrow) element
      var $pointer = angular.element(el[0].querySelector('.rm-chartist-tooltip-pointer'));
      // Chart point element, is being set on mouseenter event
      var $pointEl;
      // Timeout ID
      var hideTimer;
      // Current chart point data
      $scope.point = null;
      var adjustTooltipPosition = function (pointPosition) {
        var containerRect = el.parent()[0].getBoundingClientRect();
        var tooltipRect = el[0].getBoundingClientRect();
        var tooltipPosition = fitRectangleToTarget(pointPosition, tooltipRect, containerRect);
        var pointerPositionX = (tooltipRect.width / 2 - $pointer[0].offsetWidth / 2) - (tooltipPosition.left - pointPosition.x);
        $pointer.css('left', pointerPositionX + 'px');
        el.css({
          top: pointPosition.y + 'px',
          left: tooltipPosition.left + 'px'
        });
      };
      // Hide tooltip
      var hide = function () {
        hideTimer = $timeout(function () {
          el.css('display', 'none');
          $scope.point = null;
          if ($pointEl) {
            $pointEl.removeClass('active');
          }
        }, HIDE_DELAY);
      };
      // Show tooltip
      var show = function (data) {
        el.css('display', 'block');
        adjustTooltipPosition(data);
      };
      el.on('mouseenter', function () {
        $timeout.cancel(hideTimer);
      });
      el.on('mouseleave', hide);
      $scope.$on('rm-chartist:point:mouseenter', function (event, data, target) {

        if ($pointEl && $pointEl !== target) {
          //if mouse hovered on new point - reset active state from old one
          $pointEl.removeClass('active');
        }

        $pointEl = angular.element(target).addClass('active');
        $timeout.cancel(hideTimer);
        $scope.point = data;

        //notify angular $digest cycle
        $timeout(function () {
          show(data);
        });
      });

      $scope.$on('rm-chartist:point:mouseleave', hide);
      angular.element($window).on('resize orientationchange', hide);
    }
  };
});
